import {
    EditOutlined,
    EyeOutlined,
    LinkOutlined
} from '@ant-design/icons';
import { Flex, Input, Row, Skeleton, Space, Table, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import styles from "../styles/Payment.module.css";
import TableAntd from 'components/elements/Table/Table';
import { get2DecimalPointsWithCommas } from 'components/numberFormatDigits';
import { useCallback, useState } from 'react';
import { ReactComponent as Warning2 } from "../../../assets/icon/warning2.svg"
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TableAntdFix from 'components/elements/Table/TableFixPage';

const EmployeeIncompleteTable = ({
    dataSource = [],
    onChange = () => { },
    pagination = {},
    isLoading = false,
    // onView = () => { },
    // onEdit = () => { },
    step = 0,
    getButtonByStep = () => { },
    visible = false,
    tabKey = "",
    selectedRowKeys = [],
    setSelectedRowKeys = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const params = useParams()


    useMemo(() => {
        setSelectedRowKeys([])
    }, [tabKey])
    const { roles } = useSelector((state) => state.company);

    const onViewEmployee = useCallback(
        (obj) => {
            console.log("obj", obj, params);
            const id = obj?.employee?.employeeId;
            // console.log("onView", EMPLOYEE_MENU_LIST.filter(o => o.label), `${EMPLOYEE_MENU_LIST.filter(o => o.label)?.[0].key}`);
            // navigate("/configuration/attendance", { state: { selectedTab: 'shifts' } });
            if (id) navigate(`/employee/${id}/employee_info`, { state: { selectedTab: `/payroll/payment/${params.id}` } });
        },
        [navigate, params]
    );


    const onSelectChange = (selectedRowKeys, selectedRows, info) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys
            , selectedRows
            , info);
        setSelectedRowKeys(selectedRowKeys);
    };

    function getCheckboxProps() {
        if (tabKey == 'incompleteData') {
            return {
                getCheckboxProps: (record) => ({
                    disabled: Object.entries(record?.employee?.payrollDataEntryList || {})
                        .filter(([key, value]) => value === "N")?.length != 0,
                    // Column configuration not to be checked
                }),
            }
        } else {
            return {}
        }
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        hideSelectAll: true,
        ...getCheckboxProps()
    };

    const columns = [
        {
            title: <div className="text-table">{t("user_management.label.employee_id")}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: 'center',
            render: (_, record) => {
                console.log("record?.employee", record?.employee);
                return !roles.includes("ACCESS_EMPLOYEE") ? record?.employeeNo : <a onClick={() => {
                    console.log("click");
                    onViewEmployee(record)
                }} >{record?.employee?.employeeNo}</a>
            }
        },
        {
            title: <div className="text-table">{t("employee_list.header")}</div>,
            dataIndex: "employeeName",
            key: "employeeName",
            align: 'center',
            render: (_, record) => {
                console.log("tabKey", tabKey);
                if (tabKey == "incompleteData" && Object.entries(record?.employee?.payrollDataEntryList || {})
                    .filter(([key, value]) => value === "N")?.length != 0) {
                    return <Tooltip placement="bottom"
                        title={
                            <Flex vertical>
                                <span>{t("employee.label.fillin_form")}</span>
                                <ul>
                                    {Object.entries(record?.employee?.payrollDataEntryList || {})
                                        .filter(([key, value]) => value === "N")
                                        .map(([key]) => (
                                            <li key={key}>&#8226; {t(`employee.label.${key}`)}</li>
                                        ))}
                                </ul>
                            </Flex>}>
                        <Flex justify='left'><Warning2 />{i18n.language === 'en' ? record?.employee?.nameEn + " " + record?.employee?.surnameEn : record?.employee?.name + " " + record?.employee?.surname}</Flex>
                    </Tooltip>

                } else {

                    return (

                        <Flex justify='left'>{i18n.language === 'en' ? record?.employee?.nameEn + " " + record?.employee?.surnameEn : record?.employee?.name + " " + record?.employee?.surname}</Flex>
                    )
                }

            }
        },
        {
            title: <div className="text-table">{t("salary.label.salary")}</div>,
            dataIndex: "salary",
            key: "salary",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'>{visible ? (isNaN(record?.employee?.salary) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.employee?.salary)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'>{visible ? (isNaN(record?.employee?.salary) ? "0.00" : get2DecimalPointsWithCommas(record?.employee?.salary)) : "xxx,xxx.xx"}</Flex>
                )
            }
        },
        // {
        //     title: <div className="text-table">{t("payment.label.other_income")}</div>,
        //     dataIndex: "otherIncome",
        //     key: "otherIncome",
        //     align: 'center',
        //     render: (_, record) => {
        //         return (
        //             isLoading ? (
        //                 <Skeleton active={isLoading} />
        //             ) : (
        //                 <Flex gap="5px" justify='center'>
        //                     {
        //                         step !== 0 ?
        //                             <EyeOutlined onClick={() => onEdit(record)} /> :
        //                             <EditOutlined onClick={() => onView(record)} />
        //                     }
        //                 </Flex>
        //             )
        //         );
        //     }
        // },
        {
            title: <div className="text-table">{t('payment.label.withholding-tax')}</div>,
            dataIndex: "withholdingTax",
            key: "withholdingTax",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'>{visible ? (isNaN(record?.employee?.withholidingTax) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.employee?.withholidingTax)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'>{visible ? (isNaN(record?.employee?.withholidingTax) ? "0.00" : get2DecimalPointsWithCommas(record?.employee?.withholidingTax)) : "xxx,xxx.xx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.social_security')}</div>,
            dataIndex: "socialSecurity",
            key: "socialSecurity",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'> {visible ? (isNaN(record?.employee?.socialSecurity) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.employee?.socialSecurity)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'> {visible ? (isNaN(record?.employee?.socialSecurity) ? "0.00" : get2DecimalPointsWithCommas(record?.employee?.socialSecurity)) : "xxx,xxx.xx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.tax')}</div>,
            dataIndex: "taxRate",
            key: "taxRate",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='center'>{visible ? (isNaN(record?.employee?.taxRate) ? "xx,xxx.xx" : record?.employee?.taxRate) : "xx,xxx.xx"}</Flex>
                    <Flex justify='center'>{visible ? (isNaN(record?.employee?.taxRate) ? "0.00" : record?.employee?.taxRate) : "xxx,xxx.xx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.net_income')}</div>,
            dataIndex: "netIncome",
            key: "netIncome",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'>{visible ? (isNaN(record?.employee?.netIncome) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.employee?.netIncome)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'>{visible ? (isNaN(record?.employee?.netIncome) ? "0.00" : get2DecimalPointsWithCommas(record?.employee?.netIncome)) : "xxx,xxx.xx"}</Flex>
                )
            }
        },
    ];

    return (
        <>
            <TableAntdFix
                className={styles.table}
                style={{
                    border: '1px solid lightgray',
                    borderRadius: "8px"
                }}
                loading={isLoading}
                pagination={{
                    ...pagination,
                }}
                dataSource={dataSource}
                rowKey={(record) => record?.employee?.employeeId}
                columns={columns}
                onChange={onChange}
                // scroll={{ x: true }}
                rowSelection={(tabKey == 'employeeIn' || tabKey == 'employeeOut' || tabKey == 'incompleteData') ? rowSelection : false}

            />
            <Row justify='end' style={{
                marginTop: "10px"
            }}>
                <Flex gap={20}>

                    {getButtonByStep()}
                </Flex>
            </Row>
        </>


    );
};

export default EmployeeIncompleteTable;
